export default "__VITE_ASSET__Dq9gP7ae__"